<template>
  <div class="row">
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else class="col_12">
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Employee</span>
          <span v-else>Create a New Employee</span>
        </h1>
        <span>
          <router-link :to="{ name: 'users' }" class="btn btn_black"
            >Back to List</router-link
          >
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('first_name') },
                ]"
              >
                <label class="required">First Name</label>
                <div class="form_input">
                  <input
                    type="text"
                    class="form_global"
                    v-model="user.first_name"
                  />
                  <v-errors :errors="errorFor('first_name')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row_inline', { has_error: errorFor('email') }]"
              >
                <label class="required">Email</label>
                <div class="form_input">
                  <input
                    type="email"
                    class="form_global"
                    v-model="user.email"
                  />
                  <v-errors :errors="errorFor('email')"></v-errors>
                </div>
              </div>
              <div
                :class="['form_row_inline', { has_error: errorFor('role_id') }]"
              >
                <label>Role</label>
                <div class="form_input">
                  <select class="form_global" v-model="user.role_id">
                    <option value="">Select Role</option>
                    <option
                      v-for="role in roles"
                      :key="role.id"
                      :value="role.id"
                    >
                      {{ role.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('role_id')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('position') },
                ]"
              >
                <label class="">Position</label>
                <div class="form_input">
                  <input
                    type="text"
                    class="form_global"
                    v-model="user.position"
                  />
                  <v-errors :errors="errorFor('position')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('group_id') },
                ]"
              >
                <label>Group</label>
                <div class="form_input">
                  <select class="form_global" v-model="user.group_id">
                    <option value="">Select Group</option>
                    <option
                      v-for="group in groups"
                      :key="group.id"
                      :value="group.id"
                    >
                      {{ group.name }}
                    </option>
                  </select>
                  <v-errors :errors="errorFor('group_id')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('profile_image') },
                ]"
              >
                <label> Profile Image </label>
                <div class="form_input center_horizontally">
                  <input
                    ref="profile_image"
                    type="file"
                    class="form_global"
                    accept="image/png, image/gif, image/jpeg"
                    @input="onFileChange($event)"
                  />
                </div>
                <div class="form_row_inline mt_10" v-if="tempFile">
                  <label></label>
                  <div class="inner_img p_relative display_inline">
                    <div class="cross_ic" @click.prevent="deleteFile">
                      <i class="fas fa-times"></i>
                    </div>
                    <img :src="tempFile" alt="" height="100" width="100" />
                  </div>
                </div>
                <div v-else class="form_row_inline mt_10">
                  <label></label>
                  <img
                    v-if="user.profile_image"
                    :src="user.profile_image"
                    alt=""
                    class=""
                    width="100"
                    height="100"
                  />
                </div>
              </div>
            </div>

            <div class="col_6 pl_20">
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('last_name') },
                ]"
              >
                <label class="required">Last Name</label>
                <div class="form_input">
                  <input
                    type="text"
                    class="form_global"
                    v-model="user.last_name"
                  />
                  <v-errors :errors="errorFor('last_name')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('password') },
                ]"
              >
                <label class="required">Password</label>
                <div class="form_input">
                  <input
                    type="password"
                    class="form_global"
                    v-model="user.password"
                    autocomplete="off"
                  />
                  <v-errors :errors="errorFor('password')"></v-errors>
                </div>
              </div>

              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('joining_date') },
                ]"
              >
                <label class="">Joining date</label>
                <div class="form_input">
                  <date-picker v-model:input="user.joining_date"></date-picker>
                  <v-errors :errors="errorFor('joining_date')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('annual_leave') },
                ]"
              >
                <label class="">Annual leave</label>
                <div class="form_input">
                  <input
                    type="number"
                    class="form_global"
                    v-model="user.annual_leave"
                  />
                  <v-errors :errors="errorFor('annual_leave')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('sick_leave') },
                ]"
              >
                <label class="">Sick leave</label>
                <div class="form_input">
                  <input
                    type="number"
                    class="form_global"
                    v-model="user.sick_leave"
                  />
                  <v-errors :errors="errorFor('sick_leave')"></v-errors>
                </div>
              </div>
              <div
                :class="[
                  'form_row_inline',
                  { has_error: errorFor('compensatory_leave') },
                ]"
              >
                <label class="">Compensatory leave</label>
                <div class="form_input">
                  <input
                    type="number"
                    class="form_global"
                    v-model="user.compensatory_leave"
                    disabled
                  />
                  <v-errors :errors="errorFor('compensatory_leave')"></v-errors>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_6">
              <div class="form_row_inline">
                <label></label>
                <div class="form_input">
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="update"
                    v-if="$route.params.id"
                  >
                    Update
                  </button>
                  <button
                    class="btn btn_primary"
                    :disabled="lyLoading"
                    @click.prevent="submit"
                    v-else
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderMaskComponent from '@/components/LoaderMaskComponent.vue';
import DatePicker from '@/components/shared/DatePicker';
export default {
  name: 'user-form',
  components: { LoaderMaskComponent, DatePicker },
  data() {
    return {
      lyLoading: false,
      user: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        active: '',
        verified: '',
        profile_image: '',
        role_id: '',
        group_id: '',
        position: '',
        joining_date: '',
        annual_leave: 0,
        sick_leave: 0,
        compensatory_leave: 0,
      },
      tempFile: null,
      groups: [],
      roles: [],
    };
  },
  created() {
    if (this.$route.params.id) {
      this.loadData(this.$route.params.id);
    }
    this.getGroups();
    this.getRoles();
  },
  methods: {
    loadData(userId) {
      this.lyLoading = true;
      this.axios
        .get('/users/' + userId)
        .then((response) => {
          let userData = response.data.data;
          this.user.first_name = userData.first_name;
          this.user.last_name = userData.last_name;
          this.user.email = userData.email;
          this.user.profile_image = userData.profile_image;
          this.user.annual_leave = userData.annual_leave;
          this.user.sick_leave = userData.sick_leave;
          this.user.compensatory_leave = userData.compensatory_leave;
          this.user.group_id = userData.group_id ? userData.group_id : '';
          this.user.role_id = userData.roles[0] ? userData.roles[0].id : '';
        })
        .catch(() => {
          this.showFailMsg('No user exists!');
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
    getGroups() {
      this.axios.get('/roles').then(({ data }) => {
        this.roles = data.data;
      });
    },
    getRoles() {
      this.axios.get('/active-groups-for-relation').then(({ data }) => {
        this.groups = data.data;
      });
    },
    onFileChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      let file = event.target.files[0];
      this.user.profile_image = file;

      this.tempFile = URL.createObjectURL(file);
    },
    deleteFile() {
      this.tempFile = null;
      this.user.profile_image = null;
      this.$refs.profile_image.value = null;
    },
    submit() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      Object.keys(this.user).forEach((key) => {
        formData.append(key, this.user[key] ? this.user[key] : '');
      });

      this.axios
        .post('/users', formData)
        .then(() => {
          this.showSuccessMsg('Employee Created Successfully!');
          this.$router.push({ name: 'users' });
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
          this.showFailMsg(err.response.data.message);
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },

    update() {
      this.allErrors = null;
      this.lyLoading = true;

      let formData = new FormData();

      formData.append('_method', 'PATCH');

      Object.keys(this.user).forEach((key) => {
        formData.append(key, this.user[key] ? this.user[key] : '');
      });

      this.axios
        .post('/users/' + this.$route.params.id, formData)
        .then(() => {
          this.showSuccessMsg('Employee Update Successfully!');
        })
        .catch((err) => {
          this.allErrors = err.response.data.errors;
        })
        .finally(() => {
          this.lyLoading = false;
        });
    },
  },
};
</script>
<style scoped>
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic {
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
</style>
